import { Pipe, PipeTransform } from '@angular/core';
import { TripService } from '../../providers/trip-service/trip-service';
import * as numeral from 'numeral';
import * as turf from '@turf/turf';
import * as _ from 'lodash';

/**
 * Generated class for the DistanceAlongTripPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'distanceAlongTrip',
})
export class DistanceAlongTripPipe implements PipeTransform {
  constructor(public tripService: TripService) {}

  /**
   * Takes a value and makes it lowercase.
   */
  transform(place: any, ...args) {
    let dist = place.distance;

    if (!dist) {
      const route = this.tripService.getActiveRoute(),
        pointOnLine = turf.nearestPointOnLine(
          route,
          {
            type: 'Feature',
            properties: {},
            geometry: place.location,
          },
          { units: 'miles' }
        );
      dist = _.get(pointOnLine, 'properties.location', 100000);
    }

    if (dist < 5) {
      dist = _.round(dist, 2);
    } else {
      dist = _.round(dist);
    }

    dist = numeral(dist).format('0,000[.]00');

    return dist + ' mi along';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/distance-along-trip/distance-along-trip.ts